import React from 'react';
import styled from 'styled-components';

const ToolTipText = styled('span')({
  visibility: 'hidden',
  maxWidth: 'min(80vw, 18rem)',
  backgroundColor: '#333',
  color: '#fff',
  textAlign: 'center',
  borderRadius: '6px',
  padding: '12px 8px',
  fontSize: '0.85rem',
  position: 'absolute',
  zIndex: 1,
  bottom: '130%',
  left: '0',
  ':after': {
    content: '""',
    position: 'absolute',
    top: '100%',
    left: '24px',
    marginLeft: '-5px',
    borderWidth: '8px',
    borderStyle: 'solid',
    borderColor: '#333 transparent transparent transparent',
  },
});

const ToolTipTextBig = styled(ToolTipText)({
  width: 'min(80vw, 500px)',
});

const ToolTip = styled('div')({
  position: 'relative',
  display: 'inline-block',
  ':hover span': {
    visibility: 'visible',
  },
});

const CustomToolTip = ({ children, toolTipText }) => {
  if (!toolTipText) {
    return children;
  } else {
    const Text =
      toolTipText.split(' ').length >= 4
        ? ToolTipTextBig
        : ToolTipText;
    return (
      <ToolTip>
        {children}
        <Text>{toolTipText}</Text>
      </ToolTip>
    );
  }
};

export default CustomToolTip;
